/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck bender-url isn't supported in TypeScript yet
import { ENTERPRISE, PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';

// New as of Jan 14 2022

import MARKETING_HUB_ENT_ICON from 'bender-url!pricing-pages-ui/img/productIcons/MarketingHub_Ent.svg';
import MARKETING_HUB_PRO_ICON from 'bender-url!pricing-pages-ui/img/productIcons/MarketingHub_Pro.svg';
import MARKETING_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui/img/productIcons/MarketingHub_Starter.svg';
import SALES_HUB_ENT_ICON from 'bender-url!pricing-pages-ui/img/productIcons/SalesHub_Ent.svg';
import SALES_HUB_PRO_ICON from 'bender-url!pricing-pages-ui/img/productIcons/SalesHub_Pro.svg';
import SALES_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui/img/productIcons/SalesHub_Starter.svg';
import SERVICE_HUB_ENT_ICON from 'bender-url!pricing-pages-ui/img/productIcons/ServiceHub_Ent.svg';
import SERVICE_HUB_PRO_ICON from 'bender-url!pricing-pages-ui/img/productIcons/ServiceHub_Pro.svg';
import SERVICE_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui/img/productIcons/ServiceHub_Starter.svg';
import CONTENT_HUB_ENT_ICON from 'bender-url!pricing-pages-ui/img/productIcons/ContentHub_Ent.svg';
import CONTENT_HUB_PRO_ICON from 'bender-url!pricing-pages-ui/img/productIcons/ContentHub_Pro.svg';
import CONTENT_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui/img/productIcons/ContentHub_Starter.svg';
import OPERATIONS_HUB_ENT_ICON from 'bender-url!pricing-pages-ui/img/productIcons/OperationsHub_Ent.svg';
import OPERATIONS_HUB_PRO_ICON from 'bender-url!pricing-pages-ui/img/productIcons/OperationsHub_Pro.svg';
import OPERATIONS_HUB_STARTER_ICON from 'bender-url!pricing-pages-ui/img/productIcons/OperationsHub_Starter.svg';
export const ProductToIconMap = {
  [MARKETING]: {
    [STARTER]: MARKETING_HUB_STARTER_ICON,
    [PROFESSIONAL]: MARKETING_HUB_PRO_ICON,
    [ENTERPRISE]: MARKETING_HUB_ENT_ICON
  },
  [SALES]: {
    [STARTER]: SALES_HUB_STARTER_ICON,
    [PROFESSIONAL]: SALES_HUB_PRO_ICON,
    [ENTERPRISE]: SALES_HUB_ENT_ICON
  },
  [SERVICE]: {
    [STARTER]: SERVICE_HUB_STARTER_ICON,
    [PROFESSIONAL]: SERVICE_HUB_PRO_ICON,
    [ENTERPRISE]: SERVICE_HUB_ENT_ICON
  },
  [CMS]: {
    [STARTER]: CONTENT_HUB_STARTER_ICON,
    [PROFESSIONAL]: CONTENT_HUB_PRO_ICON,
    [ENTERPRISE]: CONTENT_HUB_ENT_ICON
  },
  [OPERATIONS]: {
    [STARTER]: OPERATIONS_HUB_STARTER_ICON,
    [PROFESSIONAL]: OPERATIONS_HUB_PRO_ICON,
    [ENTERPRISE]: OPERATIONS_HUB_ENT_ICON
  }
};
export const getProductTierToIconMap = () => {
  return ProductToIconMap;
};